import(/* webpackMode: "eager" */ "/home/runner/work/thi-beacon-frontend/thi-beacon-frontend/src/app/layout.tsx");
